// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { DnsZoneWithRelationsSchema } from './DnsZoneRelationsSchema'
import type { DnsZoneWithRelations } from './DnsZoneRelationsSchema'
import { ExternalNetworkDnsZonePolicySchema } from './ExternalNetworkDnsZonePolicySchema';

/////////////////////////////////////////
// EXTERNAL NETWORK DNS ZONE POLICY RELATION SCHEMA
/////////////////////////////////////////

export type ExternalNetworkDnsZonePolicyRelations = {
  surface: ExternalNetworkWithRelations;
  zone: DnsZoneWithRelations;
};

export type ExternalNetworkDnsZonePolicyWithRelations = z.infer<typeof ExternalNetworkDnsZonePolicySchema> & ExternalNetworkDnsZonePolicyRelations

export const ExternalNetworkDnsZonePolicyWithRelationsSchema: z.ZodType<ExternalNetworkDnsZonePolicyWithRelations> = ExternalNetworkDnsZonePolicySchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  zone: z.lazy(() => DnsZoneWithRelationsSchema),
}))